import { Popover } from "antd";
import {
  HamburgerButton,
  TextButton,
  ResponsiveContainer,
  FlexBox,
  Header2,
  ColorClass,
  ColorValue,
  FontClass,
} from "ui";
import styles from "@web/components/headers/css/Header.module.css";
import { useIsLoggedIn } from "@web/hooks/auth/useIsLoggedIn";
import { useState } from "react";
import { emptyFunction } from "shared";
import { logout } from "@web/utils/auth/logout";

function PopoverContent({
  setIsPopoverOpen,
}: {
  setIsPopoverOpen: (val: boolean) => void;
}) {
  const isLoggedIn = useIsLoggedIn();

  return (
    <FlexBox flexDirection="column" gap={24}>
      {isLoggedIn ? (
        <TextButton
          buttonThemeOrColorClass={ColorClass.Primary}
          fontClass={FontClass.NavLink}
          onClick={() => {
            setIsPopoverOpen(false);
            logout();
          }}
        >
          Log out
        </TextButton>
      ) : (
        <TextButton
          buttonThemeOrColorClass={ColorClass.Primary}
          fontClass={FontClass.NavLink}
          href="/login"
          onClick={() => {
            setIsPopoverOpen(false);
          }}
          type="link_internal"
        >
          Log in
        </TextButton>
      )}
    </FlexBox>
  );
}

export function Header(): JSX.Element {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  return (
    <div className={styles.container}>
      <ResponsiveContainer className={styles.header}>
        <HamburgerButton
          colorValue={ColorValue.Secondary}
          isShown={false}
          onClick={emptyFunction}
        />
        <Header2 colorClass={ColorClass.Primary}>Side Project Stack</Header2>
        <Popover
          content={<PopoverContent setIsPopoverOpen={setIsPopoverOpen} />}
          open={isPopoverOpen}
          onOpenChange={setIsPopoverOpen}
          placement="bottomRight"
          trigger="click"
        >
          <HamburgerButton
            colorValue={ColorValue.Secondary}
            onClick={() => setIsPopoverOpen((val) => !val)}
          />
        </Popover>
      </ResponsiveContainer>
    </div>
  );
}
